// extracted by mini-css-extract-plugin
export var inner = "index-module--inner--1331e";
export var switch_slider = "index-module--switch_slider--6e000";
export var wrapper = "index-module--wrapper--b952d";